import React from 'react'

import styled from '@emotion/styled'

import { useArcadeMigrationFeatureFlag } from '@cash-web/shared-data-access-arcade-migration'

interface Props {
  shouldStackButtons?: boolean
  shouldReverseStackedButtons?: boolean
}

const StyledDiv = styled.div<Props>`
  ${({ shouldStackButtons, shouldReverseStackedButtons, theme }) => {
    if (shouldStackButtons) {
      return `
        display: flex;
        gap: ${theme.spacing.m};
        flex-direction: ${shouldReverseStackedButtons ? 'column-reverse' : 'column'};
      `
    } else {
      return `
        display: grid;
        gap: ${theme.spacing.m};
        grid-template-columns: repeat(auto-fit, minmax(0, 1fr));
      `
    }
  }}
`

interface ButtonActionsContainerProps extends React.HTMLAttributes<HTMLDivElement> {
  shouldStackButtons?: boolean
}

export function ButtonActionsContainer({
  children,
  shouldStackButtons,
}: ButtonActionsContainerProps): React.ReactElement {
  const isArcadeMigrationEnabled = useArcadeMigrationFeatureFlag('apps')
  return (
    <StyledDiv shouldStackButtons={shouldStackButtons} shouldReverseStackedButtons={!isArcadeMigrationEnabled}>
      {children}
    </StyledDiv>
  )
}
